/**
 * ILLUSTRATIVE DATA — NOT ACTUAL CAMPAIGN RESULTS.
 * One hypothetical campaign wave. Figures are internally consistent:
 * reach 1,840 → engaged 1,178 (64%) → completed 483 (41% of engaged).
 */

export const REACH = 1840;
export const ENGAGED = 1178;

export type KpiFormat = 'int' | 'pct' | 'time';

export type Kpi = {
  label: string;
  value: number;
  format: KpiFormat;
  note: string;
};

export const KPIS: Kpi[] = [
  { label: 'HCP reach', value: REACH, format: 'int', note: 'Specialists who opened the Snak' },
  { label: 'Engagement rate', value: 64, format: 'pct', note: '1,178 interacted at least once' },
  { label: 'Average viewing time', value: 72, format: 'time', note: 'Of a ~80-second experience' },
  { label: 'Evidence exploration', value: 37, format: 'pct', note: '436 opened a study detail or reference' },
];

/** Share of engaged HCPs (n = 1,178) who interacted with each topic. */
export const ATTENTION: { label: string; source: string; share: number }[] = [
  { label: 'Blood involvement', source: 'MAVORIC · German guidance', share: 58 },
  { label: 'MINT study findings', source: 'Real-world evidence', share: 52 },
  { label: 'Long-term outcomes', source: 'MINT · PFS & TTNT', share: 47 },
  { label: 'Patient selection', source: 'B0–B2 · compartments', share: 33 },
  { label: 'Treatment management', source: 'SmPC', share: 29 },
];

export const LEARNINGS = [
  {
    figure: '58%',
    caption: 'of engaged HCPs',
    title: 'Blood involvement generated strong interest.',
    body: 'The most interacted-with topic, with the longest dwell on the B0–B2 classification panel.',
  },
  {
    figure: '1.8×',
    caption: 'limitation opens',
    title: 'Clinical outcomes attracted deeper evidence exploration.',
    body: 'HCPs viewing PFS and TTNT opened definitions and limitations at 1.8× the average panel rate.',
  },
];

export const NEXT_ACTION = {
  title: 'Create a focused blood-involvement Snak.',
  basis: 'Builds on the strongest interest signal from this wave.',
};
